module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.2569/img/iphone-frame.png"